import { useMutation } from '@tanstack/react-query';

import { TwilioPostCallType } from '../../services/Twilio/types';
import { request } from './request';

const usePostCallData = () => useMutation(async (data: TwilioPostCallType) => request('post', 'twilio/call', data));
export default usePostCallData;
